exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sentinel[data-v-4e99d6b7] {\n  height: 1px;\n}\n", ""]);

// exports
